import React from "react";
import Navbar from "@/components/Navbar";
import Calculator from "@/components/Calculator";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import Seo, {
  localBusinessSchema,
  faqSchema,
  breadcrumbSchema,
} from "@/components/Seo";
import { CONTACT, FAQ } from "@/lib/content";

function PageShell({ testid, seo, h1, children }) {
  return (
    <div data-testid={testid} className="min-h-screen bg-[#0c0c0f] text-white">
      {seo}
      <Navbar />
      <main className="pt-16 md:pt-20">
        <h1 className="sr-only">{h1}</h1>
        {children}
      </main>
      <Footer />
    </div>
  );
}

export function CalculatorPage() {
  return (
    <PageShell
      testid="calculator-page"
      h1="Auto Detailing Price Calculator — Edmonton"
      seo={
        <Seo
          title="Price Calculator — PPF, Ceramic Coating & Detailing in Edmonton"
          description="Get an instant price range for Paint Protection Film, Ceramic Coating, Paint Correction, Detailing and more. Pick your vehicle size, service and options — then book in one click."
          keywords="PPF cost Edmonton, ceramic coating price Edmonton, auto detailing prices Edmonton"
          path="/calculator"
          jsonLd={[
            localBusinessSchema({ contact: CONTACT }),
            breadcrumbSchema([
              { name: "Home", path: "/" },
              { name: "Price Calculator", path: "/calculator" },
            ]),
          ]}
        />
      }
    >
      <Calculator />
      <CTA />
    </PageShell>
  );
}

export function FaqPage() {
  return (
    <PageShell
      testid="faq-page"
      h1="Frequently Asked Questions — WTD Detailing & Tint Edmonton"
      seo={
        <Seo
          title="FAQ — PPF & Ceramic Coating Questions | WTD Detailing & Tint Edmonton"
          description="Answers to common questions about PPF warranties, ceramic coating durability, appointment times and aftercare at WTD Detailing & Tint Edmonton."
          keywords="PPF questions Edmonton, ceramic coating FAQ Alberta"
          path="/faq"
          jsonLd={[
            localBusinessSchema({ contact: CONTACT }),
            faqSchema(FAQ),
            breadcrumbSchema([
              { name: "Home", path: "/" },
              { name: "FAQ", path: "/faq" },
            ]),
          ]}
        />
      }
    >
      <Faq />
      <CTA />
    </PageShell>
  );
}

export function ContactPage() {
  return (
    <PageShell
      testid="contact-page"
      h1="Contact WTD Detailing & Tint — Edmonton Studio"
      seo={
        <Seo
          title="Contact & Location — WTD Detailing & Tint Studio in Edmonton, AB"
          description="Book your visit at WTD Detailing & Tint — Edmonton's premium window tint, PPF and detailing studio. Phone, email, hours and location. By appointment."
          keywords="WTD Detailing contact, detailing studio Edmonton address, tint shop Edmonton phone"
          path="/contact"
          jsonLd={[
            localBusinessSchema({ contact: CONTACT }),
            breadcrumbSchema([
              { name: "Home", path: "/" },
              { name: "Contact", path: "/contact" },
            ]),
          ]}
        />
      }
    >
      <Contact />
    </PageShell>
  );
}
